import React from 'react';
import Votes from '../votes/votes';

import {CommentsIcon} from '../comments/';

import './listing-collaboration.less';


const ListingCollaboration = (props) => {
    const {stay, listingId, tripBoardUuid, ...rest} = props;
    const {dateRange} = stay || {};
    const {arrival, departure} = dateRange || {};

    return (
        <div className="listing-collaboration">
            <Votes
                className="listing-collaboration__votes"
                endDate={departure}
                listingId={listingId}
                tripBoardUuid={tripBoardUuid}
                startDate={arrival}
                useSmallButton
                sm
            />
            <CommentsIcon
                boardId={tripBoardUuid}
                listingId={listingId}
                isSmall
                {...rest}
            />
        </div>
    );
};

export default ListingCollaboration;



// WEBPACK FOOTER //
// ./src/universal/tripboard/listing/listing-collaboration.js